import { Modal } from 'react-bootstrap';
import { GreenCheck } from '../../../../../assets/images/images';

function Component({ isOpen, onClose }) {
    return (
        <Modal className='onboarding' show={isOpen} onHide={onClose} backdrop="static">
            <Modal.Header >
                <figure><img src={GreenCheck} alt="Logo" /></figure>
            </Modal.Header>

            <Modal.Body className='text-center'>
                <h5 className='m6'>Proposal Created Successfully</h5>
            </Modal.Body>
        </Modal>
    );
}

export default Component;
